<template>
  <iModal
    :visible="reviewApplicationModalOpen"
    title="Review Application"
    :max-width="600"
    @close="closeModal"
  >
    <template #body>
      <iColumn gap="large">
        <iColumn gap="none">
          <iSubHeading>{{ application.publication.name }}</iSubHeading>
        </iColumn>
        <iTextArea
          v-model="application.applicationMessage"
          label="Message"
          placeholder="Enter application message..."
          :rows="5"
          width="fill"
          readonly
        />
        <iText v-if="error" variant="error">
          {{ error }}
        </iText>
      </iColumn>
    </template>
    <template #footer>
      <iRow align="right" gap="standard">
        <iColumn width="hug">
          <iButton
            variant="secondary"
            :is-loading="isLoadingRejectApplication"
            loading-spinner-position="inside"
            @click="reject"
          >
            Reject
          </iButton>
        </iColumn>
        <iColumn width="hug">
          <iButton
            variant="primary"
            :is-loading="isLoadingAcceptApplication"
            loading-spinner-position="inside"
            @click="accept"
          >
            Accept
          </iButton>
        </iColumn>
      </iRow>
    </template>
  </iModal>
</template>

<script>
import { mapActions, mapState } from "pinia";
import { useNetworkStore } from "@/stores/network-store";

export default {
  name: "ReviewApplicationModal",
  computed: {
    ...mapState(useNetworkStore, [
      "reviewApplicationModalOpen",
      "selectedApplication",
      "isLoadingAcceptApplication",
      "isLoadingRejectApplication",
      "error",
    ]),
    application() {
      return this.selectedApplication || {};
    },
  },
  methods: {
    ...mapActions(useNetworkStore, [
      "acceptApplication",
      "rejectApplication",
      "closeReviewApplicationModal",
    ]),
    closeModal() {
      this.closeReviewApplicationModal();
    },
    accept() {
      if (!this.application.networkId || !this.application.publicationId) {
        return;
      }
      this.acceptApplication(this.application.networkId, this.application.publicationId);
    },
    reject() {
      if (!this.application.networkId || !this.application.publicationId) {
        return;
      }
      this.rejectApplication(this.application.networkId, this.application.publicationId);
    },
  },
};
</script>

<style scoped>
</style>
